import api from './api';
import { LicenseItem } from './admin';

export interface BulkCreateLicenseItemsDto {
  contentType?: string;
  filename?: string;
  resolution?: string;
  durationMin?: number;
  durationMax?: number;
  bitRateMin?: number;
  bitRateMax?: number;
  validUntil: string;
  maxPlayCount: number;
  specificFileIds?: string[];
}

export interface PreviewBulkLicenseItemsDto {
  contents: any[];
  totalCount: number;
  filters: BulkCreateLicenseItemsDto;
}

export interface BulkCreateResult {
  success: boolean;
  items: LicenseItem[];
  createdCount: number;
  message?: string;
}

export const licenseService = {
  // Preview bulk license items creation (no database changes)
  previewBulkLicenseItems: (licenseId: number, data: BulkCreateLicenseItemsDto) =>
    api.post<PreviewBulkLicenseItemsDto>(`/licenses/${licenseId}/bulk-items/preview`, data).then((res) => res.data),

  // Create bulk license items with filtering
  createBulkLicenseItems: (licenseId: number, data: BulkCreateLicenseItemsDto) =>
    api.post<BulkCreateResult>(`/licenses/${licenseId}/bulk-items`, data).then((res) => res.data),
};